// extracted by mini-css-extract-plugin
export var labelWrapper = "_ce-0";